import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'

import ChoiceButton from '@progyny/components/Buttons/ChoiceButton'
import MobileStickyActions, {
  MOBILE_STICKY_HEIGHT,
} from '@progyny/components/MobileStickyActions'
import {RelationshipDynamics, UNSET} from '@progyny/const/index'
import {useResponsive} from '@progyny/hooks/useResponsive'
import {SetupProfileSubProps} from '@progyny/pages/SetUpProfile/types'
import {useMeStore} from '@progyny/store/meStore'

const RelationshipDynamic: React.FC<SetupProfileSubProps> = (props) => {
  const {
    onboardingData,
    navigator: Navigator,
    callback,
    persistMemberData,
    goBack,
  } = props

  const isInConservativeCountry = useMeStore((s) => s.isInConservativeCountry)
  const {t} = useTranslation()
  const isMobile = useResponsive('down', 'md')
  const choices = RelationshipDynamics.filter(
    (item) =>
      item.value !== UNSET &&
      (!isInConservativeCountry() || item.value !== 'same-sex')
  ).map((item) => {
    if (isInConservativeCountry() && item.value === 'opposite-sex') {
      item.label = t('setup_profile_in_relationship')
    }
    return item
  })

  const handleChoiceClick = async (choice: string) => {
    await persistMemberData({relationshipDynamic: choice}, callback)
  }

  return (
    <>
      <Grid
        container
        justifyContent={'center'}
        sx={{pb: {xs: MOBILE_STICKY_HEIGHT, md: 0}}}
      >
        <Grid item xs={12}>
          <Box mt={3}>
            {choices.map((item) => (
              <ChoiceButton
                data-role={'relationship-dynamic-submit-button'}
                key={item.value}
                isSelected={onboardingData.relationshipDynamic === item.value}
                onClick={() => handleChoiceClick(item.value)}
                size={'large'}
              >
                {t(item.label!)}
              </ChoiceButton>
            ))}
          </Box>
        </Grid>
      </Grid>
      <MobileStickyActions>
        <Navigator
          skipDataRole={'relationship-dynamic'}
          onPrevButtonClick={goBack}
          backButtonType='outlined'
          singleCentered
          fullWidth={isMobile}
        />
      </MobileStickyActions>
    </>
  )
}

export default RelationshipDynamic
